<template>
  <div class="contractAmountCondition">
    <div class="title">
      <i class="el-icon-s-data" style="color: #006eff"></i>
      合同金额及完成情况
    </div>
    <div class="searchPart">
      <timeGroupSelect @queryValue="queryMoney"/>
      <el-select v-model="type" @change="queryMoney(val)">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div id="contractAmountChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import timeGroupSelect from "@/views/index/comp/timeGroupSelect";
import DayJS from "dayjs";

export default {
  components: {
    timeGroupSelect
  },
  data() {
    return {
      options: [
        {
          value: '1',
          label: '合同金额'
        },
        {
          value: '2',
          label: '回款金额'
        },
      ],
      type: '1',
      option: {
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            data: [],
            type: 'bar',
            smooth: true,
            lineStyle: {
              color: '#006eff'
            },
            itemStyle: { // 柱状样式
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {offset: 0, color: '#006eff'}, // 设置颜色渐变
                  {offset: 1, color: '#ffffff'},
                ]
              },
            },
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'top',//在上方显示
              textStyle: {//数值样式
                fontSize: '14px',
                color: '#006eff',
              },
            },
            symbol: 'emptyCircle', // 几何圆
            symbolSize: 10,
            areaStyle: { // 区域填充样式
              color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#006eff', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#ffffff' // 100% 处的颜色
                  }
                ],
                global: false, // 缺省为 false
              }
            }
          }
        ],
        grid: {
          left: '8%',
          right: '4%',
          top: '10%',
          // bottom: '15%',
        }
      },
      myChart: '',
      curYear:DayJS().format("YYYY"),
      // 时间段
      val: '',
    }
  },
  mounted() {
    this.initECharts();
  },
  methods: {
    initECharts() {
      let chartDom = document.getElementById('contractAmountChart');
      this.myChart = echarts.init(chartDom);
      this.option && this.myChart.setOption(this.option);
    },
    queryMoney(val) {
      this.val = val;
      const [startTime, endTime] = val;
      let url = `/Crm/Static/StaticContractAmountMonth?type=${ this.type }&startTime=${startTime}&endTime=${endTime}`;
      this.$axios.get(url).then((res) => {
        this.option.xAxis.data = res.map( (r,i,d) => {
          if(r.month>d[d.length-1].month) {
            return `${ this.curYear-1 }.${ r.month }`
          } else {
            return `${ this.curYear }.${ r.month }`
          }
        });
        this.option.series[0].data = res.map( r => r.amount);
        this.initECharts();
      });
    }
  }
}
</script>

<style scoped lang="scss">
.contractAmountCondition {
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  border: 1px solid #dfe0eb;
  border-radius: 12px;
  border-top: 3px solid #006eff;
  padding: 5px 15px;
  margin-bottom: 20px;
  background: white;
  box-shadow: 0 2px 6px 0 rgba(218, 218, 253, 65%), 0 2px 6px 0 rgba(206, 206, 238, 54%);

  .title {
    font-weight: bold;
    font-size: 18px;
    margin-top: 10px;
  }

  .searchPart {
    display: flex;
    align-items: center;
    margin-top: 1.5%;
    ::v-deep .el-select {
      width: 110px;
      margin-left: 10px;
      .el-input__inner {
        border: 1px solid #9ca6b8;
        border-radius: 9px;
      }
    }
  }

  #contractAmountChart {
    width: 100%;
    flex: 1;
  }
}
</style>
